import React from 'react'

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        padding: '10px',
        textAlign: 'center',
        borderTop: '1px solid #ddd',
        marginTop: '75px',
      }}
    >
      <p>
        (07325) 서울특별시 영등포구 의사당대로 83, 여의도동 18층
        디디18-110-엔(여의도동, 오투타워)
        <br /> 주식회사 네버비(NEVER BE)
      </p>
      <p>
        대표 : 이승철 &nbsp;|&nbsp; 사업자번호 : 895-86-01610 &nbsp;|&nbsp;
        Email : neverbe.family@gmail.com
      </p>
      <p>Copyright © NEVER BE Corp. All Rights Reserved.</p>
    </footer>
  )
}

export default Footer
